import '@mrhenry/wp--bugsnag-config';
import '@mrhenry/wp--autoplay-in-view';

import { MrAccordion, MrBlockedContent, MrCarousel, MrInputSink, MrMatchesValue, MrMenu, MrPlayPauseToggle } from '@mrhenry/wp--mr-interactive';

import './modules/inline-link-transition-duration';
import './modules/mr-icon-bar';
import './modules/mr-navigation-overlay';
import './modules/mr-video';
import './modules/mr-video-overlay';

customElements.define( 'mr-accordion', MrAccordion );
customElements.define( 'mr-blocked-content', MrBlockedContent );
customElements.define( 'mr-carousel', MrCarousel );
customElements.define( 'mr-input-sink', MrInputSink );
customElements.define( 'mr-matches-value', MrMatchesValue );
customElements.define( 'mr-menu', MrMenu );
customElements.define( 'mr-play-pause-toggle', MrPlayPauseToggle );
